import { z } from 'zod';
import { AdressesLabel } from '../types/Adresses';

export const addresScheam = z.object({
  title: z.string(),
  location: z.object({
    lon: z.number(),
    lat: z.number(),
  }),
  details: z
    .object({
      entrance: z.string().optional(),
      intercom: z.string().optional(),
      floor: z.string().optional(),
      apartment: z.string().optional(),
      comment: z.string().optional(),
    })
    .optional(),
  label_type: z.nativeEnum(AdressesLabel).optional(),
  label_value: z.string().optional(),
});

export type AddressSchemaForm = z.infer<typeof addresScheam>;
